<template>
    <van-field
        :placeholder="placeholder"
        :class="vClass"
        clearable
        maxlength="12"
        v-model="fieldValue"
        :type="type"
    >
        @click="iconClick" />
        <div slot="right-icon" class="bh bstart">
            <zb-warning :message="message" />
            <van-icon :name="icon" class="pass-ico" size="5.5vw" @click="iconClick"></van-icon>
        </div>
    </van-field>
</template>
<script>
export default {
    model: {
        prop: "value",
        event: "updateValue"
    },
    props: {
        value: null,
        message: null,
        placeholder: null,
        vClass: null
    },
    data() {
        return {
            isPass: true,
            fieldValue: ""
        };
    },
    computed: {
        icon() {
            return this.isPass ? "closed-eye" : "eye-o";
        },
        type() {
            return this.isPass ? "password" : "";
        }
    },
    watch: {
        fieldValue(v) {
            this.$emit("updateValue", v);
        }
    },
    methods: {
        iconClick: function() {
            this.isPass = !this.isPass;
        }
    }
};
</script>
<style lang="scss" scoped>
.pass-ico {
    margin-left: 10px;
}
</style>
